import { Component, ReactNode } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Event } from '@iwoca/frontend-tracking-library/lib/ampli';
import { t } from '@lingui/macro';
import { ErrorCard } from 'components/ErrorCard/ErrorCard';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
  locale: string;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch() {
    // have to assert type as we are using hardcoded tracking events and can not use the tracking hook here
    tracking.ampli.track(
      AMPLITUDE_EVENTS.typescriptErrorCaught as unknown as Event,
    );
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorCard
          className={styles.errorCard}
          code={500}
          message={t`Sorry, an internal error occurred. Please try again later.`}
          action={<Link to={PATH_NAMES.home()}>{t`Return to dashboard`}</Link>}
        />
      );
    }

    return this.props.children;
  }
}
